import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { CommonChannelMailFeatureModule, CommonCustomerFeatureModule, TRANSLATION_NS } from '@contact/upgrade';

import { HistoryStoreModule } from './store/history-store.module';

@NgModule({
  imports: [
    CommonCustomerFeatureModule,
    CommonChannelMailFeatureModule,

    /**
     * History modules
     */
    HistoryStoreModule,
  ],
})
export class HistoryCoreForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: HistoryCoreForRootModule) {
    if (parentModule) throw new Error(`[HistoryCoreForRootModule] module is already loaded`);
  }

  static instance(): ModuleWithProviders<HistoryCoreForRootModule> {
    return {
      ngModule: HistoryCoreForRootModule,
      providers: [
        {
          provide: TRANSLATION_NS,
          useValue: 'history',
          multi: true,
        },
      ],
    };
  }
}
